import { useEffect, useState } from "react";
import { Loader } from "@/components/shared/loader";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import {
  useNotificationPreferences,
  useUpdatePreferences,
} from "@/features/notifications/hooks/useNotifications";
import { NOTIFICATION_EVENTS } from "@/features/notifications/constants/event-labels";

export function PreferencesForm() {
  const { data, isLoading } = useNotificationPreferences();
  const updateMutation = useUpdatePreferences();

  const [preferences, setPreferences] = useState<Record<string, boolean>>({});

  useEffect(() => {
    if (data) setPreferences(data.preferences);
  }, [data]);

  async function handleSave() {
    await updateMutation.mutateAsync({ preferences });
  }

  if (isLoading) return <Loader />;

  return (
    <Card>
      <CardContent className="space-y-4 pt-6">
        <p className="text-sm text-muted-foreground">
          اختر الإشعارات التي ترغب باستلامها عبر البريد الإلكتروني.
        </p>
        {NOTIFICATION_EVENTS.map((event) => (
          <div
            key={event.key}
            className="flex items-center justify-between rounded-lg border border-border p-3"
          >
            <Label>{event.label}</Label>
            <Switch
              checked={preferences[event.key] !== false}
              onCheckedChange={(checked) =>
                setPreferences((prev) => ({ ...prev, [event.key]: checked }))
              }
            />
          </div>
        ))}
        <Button onClick={handleSave} disabled={updateMutation.isPending}>
          حفظ التفضيلات
          {updateMutation.isPending && <Loader className="mr-2" />}
        </Button>
      </CardContent>
    </Card>
  );
}
